import type { CurrentGameweekResponse } from './api';

export type GameweekMode = 'REPLAY' | 'LIVE' | 'PREVIEW';

export interface SelectedGameweekContext {
  selectedGameweek: number | null;
  currentGameweek: number | null;
  mode: GameweekMode | null;
  apiScope: 'live' | 'preview' | null;
}

export function resolveSelectedGameweekContext(
  state: CurrentGameweekResponse | undefined,
  selectedGameweek: number | null,
): SelectedGameweekContext {
  const currentGameweek = state?.gameweek ?? null;
  const selected = selectedGameweek ?? currentGameweek;
  if (selected === null || currentGameweek === null) {
    return { selectedGameweek: selected, currentGameweek, mode: null, apiScope: null };
  }
  if (selected < currentGameweek) {
    return { selectedGameweek: selected, currentGameweek, mode: 'REPLAY', apiScope: null };
  }
  if (selected > currentGameweek) {
    return { selectedGameweek: selected, currentGameweek, mode: 'PREVIEW', apiScope: 'preview' };
  }
  return { selectedGameweek: selected, currentGameweek, mode: 'LIVE', apiScope: 'live' };
}

export function syncSelectedGameweek(
  selectedGameweek: number | null,
  previousCurrentGameweek: number | null,
  currentGameweek: number,
): number {
  if (selectedGameweek === null) return currentGameweek;
  if (previousCurrentGameweek !== null && selectedGameweek === previousCurrentGameweek && previousCurrentGameweek !== currentGameweek) {
    return currentGameweek;
  }
  return selectedGameweek;
}

export function adjacentGameweek(gameweek: number, delta: -1 | 1, min = 1, max = 38): number | null {
  const next = gameweek + delta;
  return next >= min && next <= max ? next : null;
}
